import type { KarlCustomPayload } from "@/components/document-chat/services/streamEventTypes";
import {
  ChatStatus,
  KarlEventContent,
  KarlNodeRaw,
  ProcessingNode,
  StreamPhase
} from "@/constants/enums";
import type { DocumentChatRuntime } from "../types";

/**
 * Handles PROGRESS events for workflow state transitions
 *
 * @param payload - The progress event payload
 * @param runtime - The document chat runtime store interface
 */
export function handleProgressEvent(
  payload: KarlCustomPayload,
  runtime: DocumentChatRuntime
): void {
  const c = String(payload.content ?? "").toUpperCase();
  const nodeName = String(payload.node ?? "").toLowerCase();

  if (c === KarlEventContent.START) {
    // Question generation starting (supports both QuestionGenerator and QuestionAnalyzer)
    if (nodeName === KarlNodeRaw.QuestionGenerator || nodeName === KarlNodeRaw.QuestionAnalyzer) {
      runtime.update({
        phase: StreamPhase.THINKING,
        currentNode: ProcessingNode.QUESTION_GENERATOR,
        processingStagesComplete: false
      });
    }
  } else if (c === KarlEventContent.ANSWERING) {
    // Transitioning to answer generation
    // Mark all processing stages as complete and transition to answering phase
    runtime.update({
      currentNode: ProcessingNode.ANSWER_QUESTION,
      processingStagesComplete: true,
      phase: StreamPhase.ANSWERING
    });
    runtime.markAnswerStart();
  } else if (c === KarlEventContent.FINISHED) {
    // Node finished processing - don't reset currentNode to keep UI visible
    // until next stage starts or workflow completes
    if (nodeName === KarlNodeRaw.FinalizeAnswer) {
      runtime.update({
        status: ChatStatus.CLOSED,
        phase: StreamPhase.DONE,
        currentNode: ProcessingNode.IDLE,
        processingStagesComplete: false
      });
    }
  }
}
